import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import googleAnalyticsService from '../services/googleAnalyticsService';

/**
 * Google Analytics Tracker Component
 * Automatically initializes GA and tracks page views on route changes
 */
const GoogleAnalyticsTracker = () => {
  const location = useLocation();

  // Initialize Google Analytics on component mount
  useEffect(() => {
    googleAnalyticsService.init();
  }, []);

  // Track page views on route changes
  useEffect(() => {
    if (googleAnalyticsService.isInitialized) {
      const path = location.pathname + location.search;
      const title = document.title || 'Gravity Point Media';
      
      googleAnalyticsService.trackPageView(path, title);
    }
  }, [location]);

  // This component doesn't render anything
  return null;
};

export default GoogleAnalyticsTracker;
